import React, { useMemo, useState } from 'react'

import clsx from 'clsx'

import InputSearch from 'components/InputSearch'
import { useEventContext } from 'context/EventContext'
import debounce from 'helpers/debounce'

import classes from './Search.module.scss'

const filterIntegrationsLocally = (integrations, query) => {
  if (!integrations) return []
  const lowerQuery = query.toLowerCase()
  return integrations.filter(integration => integration.name?.toLowerCase().includes(lowerQuery))
}

/** @type {import("./types").default} */
const Search = ({ className, integrations, setFilteredResults, setIsLoading }) => {
  const [search, setSearch] = useState('')
  const eventContent = useEventContext({
    engagementComponent: 'product_integrations',
  })

  const onClear = () => {
    setSearch('')
    setFilteredResults(null)

    eventContent.sendEvent({
      engagementDetails: 'search-bar-integrations',
      engagementComponent: 'product_integrations',
      name: 'engagement_search_bar',
      engagementDestination: 'erase-search_integration',
    })
  }

  const fetchIntegrations = useMemo(
    () =>
      debounce(async query => {
        if (query.length < 3) {
          setFilteredResults(null)
          setIsLoading(false)
          return
        }

        setIsLoading(true)

        // Always use client-side filtering
        const localResults = filterIntegrationsLocally(integrations, query)
        setFilteredResults(localResults)
        setIsLoading(false)
      }, 200),
    [integrations, setFilteredResults, setIsLoading]
  )

  const handleSearch = event => {
    const { value } = event.target
    setSearch(value)
    fetchIntegrations(value)
  }

  return (
    <div className={clsx('Search', classes.root, className)}>
      <InputSearch
        testId="InputSearch-body"
        value={search}
        placeholder="Search for an integration"
        onChange={handleSearch}
        onClear={onClear}
        className={classes.searchInput}
        onFocus={() =>
          eventContent.sendEvent({
            engagementDetails: 'search-bar-integrations',
            engagementComponent: 'product_integrations',
            name: 'engagement_search_bar',
            engagementDestination: 'search_select-search-bar',
          })
        }
      />
    </div>
  )
}

export default Search
